
<template>
  <div class="title" style="margin: auto;justify-content: center">
    <div class="content-title">
      <div class="title-head">
        <div class="title-cn">客户资产与消费&amp;收入分析报告</div><br>
<!--        <div class="title-en">CUSTOMER ASSET AND CONSUMPTION&amp;INCOMING ANALYSIS REPORT</div>-->
        <div class="custom-title">姓名：{{ dataMap.custom.name }}&nbsp;&nbsp;&nbsp;数据来源：<span v-for="(bank, i) in homeStat.billTypeList" :key="`bank-${i}`">  {{ bank }} &nbsp;</span>&nbsp;&nbsp;账单周期：{{ homeStat.startTime }} 到{{homeStat.endTime}}&nbsp;合计：{{ homeStat.statMonth }}个月
       &nbsp;&nbsp;<span v-if="homeStat.counterparty">
  工作单位：{{ homeStat.counterparty }}
</span>
          &nbsp;&nbsp;<span v-if="homeStat.isWhiteing.fromAddr">
  邮箱地址：{{ homeStat.isWhiteing.fromAddr }}
</span>
          &nbsp;&nbsp;<span v-if="homeStat.isWhiteing.isWhite">
  <span :style="{ color: homeStat.isWhiteing.isWhite === '否' ? 'red' : 'inherit' }">是否白名单：{{ homeStat.isWhiteing.isWhite }}</span>
</span>
        </div>
      </div>
    </div>
    <div class="title-foot1">
      <Row :gutter="10" justify="center">
        <Col span="6" justify="center">
          <div class="score" title="评分越高，客户信用越好，35分以下建议拒绝 35-45分慎重评估，45-70分综合评估，70以上建议通过。">
            <div class="pf" >
              <div class="row1 font1" >{{ score.creditRatingScore }}</div>
              <div class="trapezoid t-bg1"></div>
            </div>
            <div class="row2 bg1" >信用风险评分</div>
          </div>
        </Col>
        <Col span="6">
          <div class="score" title="评分依据收消费资产等计算，评分越高，还款能力越强依据客户购买车价综合评估。">
            <div class="pf" >
              <div class="row1 font2" >{{ score.consumptionCapacityScore }}</div>
              <div class="trapezoid t-bg2"></div>
            </div>
            <div class="row2 bg2" >还款能力评分</div>
          </div>
        </Col>
        <Col span="6">
          <div class="score">
            <div class="pf" >
              <div class="row1 font3" >{{ homeStat.hitRiskListNum }}</div>
              <div class="trapezoid t-bg3"></div>
            </div>
            <div class="row2 bg3" >风险命中数量</div>
          </div>
        </Col>
        <Col  span="6">
          <div class="score">
            <div class="pf" >
              <div class="row1 font4" v-if="homeStat && homeStat.riskDetailList && homeStat.riskDetailList.length > 0">
                <br>
              </div>
              <div class="font4-content" style="font-size: 0.7vw;white-space: nowrap;" v-if="homeStat && homeStat.riskDetailList && homeStat.riskDetailList.length > 0">
                <div style="line-height: 83pt;" v-if="homeStat.riskDetailList.length === 1">
                  <p v-for="(item, index) in homeStat.riskDetailList" :key="index">
                    {{item}}
                  </p>
                </div>
                <div style="line-height: 40pt;" v-if="homeStat.riskDetailList.length === 2">
                  <p v-for="(item, index) in homeStat.riskDetailList" :key="index">
                    {{item}}
                  </p>
                </div>
                <div style="line-height: 25pt;" v-if="homeStat.riskDetailList.length === 3">
                  <p v-for="(item, index) in homeStat.riskDetailList" :key="index">
                    {{item}}
                  </p>
                </div>
                <div style="line-height: 20pt;" v-if="homeStat.riskDetailList.length === 4">
                  <p v-for="(item, index) in homeStat.riskDetailList" :key="index">
                    {{item}}
                  </p>
                </div>
                <br>
              </div>
              <div v-else class="row1 font4-null" >
                无
              </div>
              <div class="trapezoid t-bg4"></div>
            </div>
            <div class="row2 bg4" >风险提示</div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="title-foot2">
      <Row :gutter="40" justify="center">
        <Col span="6">
          <div class="total-bill" style="color:#1242CD;">
<!--            <div class="tb-top" style="background: #1242CD;">-->
<!--              <img class="tb-top-mb-img" src="../../../../assets/images/content-v4/title/hzzc.png"  alt="">-->
<!--            </div>-->
            <div class="tb-font">
              汇总支出
            </div>
            <div class="tb-foot">
              <div class="tb-ty tb-ty-bg1">
              </div>
              <div class="tb-num">
                <span style="white-space:nowrap;"><span class="wan">&#9650;</span><span v-if="homeStat.payout.hzPayout">{{formattedMoney( homeStat.payout.hzPayout.money) }}</span><span v-else>0.00</span><span class="wan">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill" style="color:#4422D1;">
            <div class="tb-font">
              汇总收入
            </div>
            <div class="tb-foot">
              <div class="tb-ty tb-ty-bg2">
              </div>
              <div class="tb-num">
                <span style="white-space:nowrap;"><span class="wan">&#9650;</span><span v-if="homeStat.incoming.hzIncoming">{{formattedMoney( homeStat.incoming.hzIncoming.money) }}</span><span v-else>0.00</span><span class="wan">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill" style="color: #F31F1C;">
<!--            <div class="tb-top" style="background: #F31F1C;">-->
<!--              <img class="tb-top-mb-img" src="../../../../assets/images/content-v4/title/zzzc.png"  alt="">-->
<!--            </div>-->
            <div class="tb-font">
              转账支出
            </div>
            <div class="tb-foot">
              <div class="tb-ty tb-ty-bg3">
              </div>
              <div class="tb-num">
                <span style="white-space:nowrap;"><span class="wan">&#9650;</span><span v-if="homeStat.payout.transfer">{{ formattedMoney(homeStat.payout.transfer.money) }}</span><span  v-else>0.00</span><span class="wan">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill" style="color: #00D376;">
<!--            <div class="tb-top" style="background: #00D376;">-->
<!--              <img class="tb-top-mb-img" src="../../../../assets/images/content-v4/title/zzsr.png" style=""  alt="">-->
<!--            </div>-->
            <div class="tb-font">
              转账收入
            </div>
            <div class="tb-foot">
              <div class="tb-ty tb-ty-bg4">
              </div>
              <div class="tb-num">
                <span style="white-space:nowrap;"><span class="wan">&#9650;</span><span v-if="homeStat.incoming.transfer">{{formattedMoney( homeStat.incoming.transfer.money) }}</span><span  v-else>0.00</span><span class="wan">万</span></span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>

export default {
  name: 'content-title',
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object
  },
  data () {
    return {
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat, this.$parent.score)
  },
  methods: {
    setData (dataMap, homeStat, score) {
      this.dataMap = dataMap
      this.homeStat = homeStat
      this.score = score
    },
    formattedMoney (value) {
      if (!value) return '0.00'
      const numberInTenThousand = value / 10000
      const roundedNumber = Math.round(numberInTenThousand * 100) / 100
      return roundedNumber.toFixed(2)
    }
  }
}
</script>
<style>
.content-title {
  height: 140pt;
  background: #f5f7f9;
  position: relative;
  color: white;
  overflow: visible;
}
.title-head {
  background-image: url(../../../../assets/images/content-v4/title/head-bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.title-cn {
  margin-left: 5%;
  margin-top: 20pt;
  margin-bottom: -10pt;
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 40pt;
  color: #1242CD;
}
.title-en {
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  font-size: 12pt;
  color: #999999;
  margin-left: 90pt;
  letter-spacing: 0.16em;
}
.custom-title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14pt;
  color: #333333;
  margin-left: 5%;
  margin-top: -4pt;
}
.title-foot1 {
  margin-top: 25pt;
}
.score {
  position:relative;
  margin: auto;
  width: 70%;
  aspect-ratio: 50 / 3;
}
.pf {
  position:relative;
  width: 100%;
  height: 100pt;
}
.row1 {
  width: 70%;
  font-size: 45pt;
  font-weight: bold;
  font-family: MicrosoftYaHei;
  text-align: center;
  position: absolute;
  bottom: 0;
  z-index: 2;
  line-height: 100pt;
  margin-left: 15%;
  margin-right: 15%;
}
.font1 {
  color: #1242CD;
  background-image: url(../../../../assets/images/content-v4/title/xyfxpf.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font2 {
  color: #4422D1;
  background-image: url(../../../../assets/images/content-v4/title/hknlpf.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font3 {
  color: #F31F1C;
  background-image: url(../../../../assets/images/content-v4/title/fxmzsl.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font4 {
  background-image: url(../../../../assets/images/content-v4/title/fxts.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font4-content {
  color: #FF9A99;
  font-size: 14pt;
  width: 70%;
  font-weight: bold;
  font-family: MicrosoftYaHei;
  text-align: center;
  position: absolute;
  bottom: 0;
  z-index: 2;
  margin-left: 15%;
  margin-right: 15%;
}
.font4-null {
  color: #FF9A99;
  background-image: url(../../../../assets/images/content-v4/title/fxts.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.trapezoid {
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 1;
  aspect-ratio: 50 / 3;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.t-bg1 {
  background-image: url(../../../../assets/images/content-v4/title/blue-bg.png);
}
.t-bg2 {
  background-image: url(../../../../assets/images/content-v4/title/purple-bg.png);
}
.t-bg3 {
  background-image: url(../../../../assets/images/content-v4/title/red-bg.png);
}
.t-bg4 {
  background-image: url(../../../../assets/images/content-v4/title/pink-bg.png);
}
.row2 {
  width: 100%;
  aspect-ratio: 10 / 1;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
  font-weight: Bold;
  font-size: 20pt;
  line-height: 45pt;
  text-align: center;
}
.bg1 {
  background: #1242CD;
}
.bg2 {
  background: #4422D1;
}
.bg3 {
  background: #F31F1C;
}
.bg4 {
  background: #FF9A99;
}
.title-foot2 {
  margin-top: 15pt;
}
.total-bill {
  text-align:center;
  margin-left: 20%;
  margin-right: 20%;
}
.tb-top {
  width: 60pt;
  height: 60pt;
  margin: auto;
  box-shadow: -5pt 10pt 14pt 0pt rgba(0,0,0,0.11);
  border-radius: 50%;
}
.tb-top-mb-img {
  margin-top: 30%;
  background-size: cover;
  width: 30pt;
}
.tb-font {
  margin: auto;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 22pt;
}
.tb-foot {
  margin-top: 10pt;
  width: 100%;
  height: 110pt;
  position: relative;
  justify-content: center;
  align-items: center;
}
.tb-ty {
  width: 100%;
  height: 86pt;
  position: absolute;
}
.tb-ty-bg1 {
  background: url(../../../../assets/images/content-v4/title/ty1.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg2 {
  background: url(../../../../assets/images/content-v4/title/ty2.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg3 {
  background: url(../../../../assets/images/content-v4/title/ty3.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg4 {
  background: url(../../../../assets/images/content-v4/title/ty4.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-num {
  font-size: 40pt;
  font-weight: bold;
  line-height: 45pt;
  text-align: center;
}
.wan {
  font-size: 18pt;
}
</style>
